export const iconFontAwesomeSecurityDungeon = (
	<i className="fa-solid fa-dungeon"></i>
);
